export function getRegistryBaseUrl() {
  if (!(import.meta as any).env.VITE_MOCK && process.env.NODE_ENV === 'development') {
    return `${window.location.origin}/proxy-o5`;
  }

  let passedPortal = false;
  const host = window.location.host.split('.').reduce((acc, curr) => {
    if (curr === 'portal' || curr === 'web') {
      passedPortal = true;
      return acc ? `${acc}.o5` : 'o5';
    }

    if (passedPortal) {
      return acc ? `${acc}.${curr}` : curr;
    }

    return acc;
  }, '');

  if (!host) {
    return `https://o5.devcore.zones.interchangefi.com`;
  }

  return `https://${host}`;
}
